import { getLabelMessage } from '@gef-ui/localization/messages';
import Phone from '@gef-ui/material-icons/Phone';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { errorPropType } from '../../constants';
const SimpleError = ({ error, showReport })=>{
    const description = error?.shortDescription || error?.longDescription;
    const shouldShowReport = (error?.showReport ?? true) || showReport;
    const header = error?.components?.Header ? /*#__PURE__*/ React.createElement(error.components.Header, null) : /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        align: "center"
    }, error?.heading ? error?.heading : getLabelMessage('errors:publicHeading'));
    const body = error?.components?.Body ? /*#__PURE__*/ React.createElement(error.components.Body, null) : /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        align: "center"
    }, description ? description : getLabelMessage('errors:publicCommonDescription'));
    const actions = error?.components?.Actions ? /*#__PURE__*/ React.createElement(error.components.Actions, null) : null;
    return /*#__PURE__*/ React.createElement(Stack, {
        spacing: 3,
        sx: {
            alignItems: 'center',
            px: 3,
            py: 1
        }
    }, header, body, shouldShowReport ? /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        sx: {
            alignItems: 'center',
            gap: 1.25
        }
    }, /*#__PURE__*/ React.createElement(Phone, {
        color: "primary"
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: "primary"
    }, getLabelMessage('errors:publicKC'))) : null, actions);
};
SimpleError.propTypes = {
    error: errorPropType,
    showReport: PropTypes.bool
};
export default SimpleError;
